import React from 'react';
import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@contexts/AuthContext';
import { usePermission, SUPPLIER_PERMISSIONS } from '@hooks/usePermissions';
import { SuspenseWrapper } from '@components';
import { LazySupplierList } from '@components/lazy';

export const SuppliersPage: React.FC = () => {
  const navigate = useNavigate();
  useAuth();

  // Check if user has permission to create suppliers
  const { hasPermission: canCreateSupplier } = usePermission(SUPPLIER_PERMISSIONS.CREATE);

  const handleAddSupplier = () => {
    navigate('/suppliers/new');
  };

  return (
    <div className="max-w-7xl mx-auto">
      <div className="mb-8">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold text-secondary-800 mb-2">
              Supplier Management
            </h1>
            <p className="text-secondary-600">
              View and manage all suppliers in your system
            </p>
          </div>
          {canCreateSupplier && (
            <button
              onClick={handleAddSupplier}
              className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 transition-colors"
            >
              <Plus className="w-4 h-4 mr-2" />
              Add Supplier
            </button>
          )}
        </div>
      </div>

      <SuspenseWrapper>
        <LazySupplierList />
      </SuspenseWrapper>
    </div>
  );
};
